import { render, staticRenderFns } from "./BusinessApplicationList.vue?vue&type=template&id=279c5870&"
import script from "./BusinessApplicationList.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports